import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as PhilaUI from '@phila/phila-ui';
import { ClientTable } from 'vue-tables-2';
import { ServerTable } from 'vue-tables-2';
import Breadcrumbs from './components/Breadcrumbs'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, length, min, numeric } from 'vee-validate/dist/rules';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faSort } from '@fortawesome/fontawesome-free-solid';
import VueFuse from 'vue-fuse';
import moment from 'moment';
import VueMeta from 'vue-meta';

import configMixin from './util/config-mixin';

let config = {
  map: {
    mbStyle: {
      version: 8,
      sources: {},
      glyphs: '//fonts.openmaptiles.org/{fontstack}/{range}.pbf',
      sources: {
        pwd: {
          tiles: [
            'https://tiles.arcgis.com/tiles/fLeGjb7u4uXqeF9q/arcgis/rest/services/CityBasemap/MapServer/tile/{z}/{y}/{x}',
          ],
          type: 'raster',
          tileSize: 256,
        },
        pwdLabels: {
          tiles: [
            'https://tiles.arcgis.com/tiles/fLeGjb7u4uXqeF9q/arcgis/rest/services/CityBasemap_Labels/MapServer/tile/{z}/{y}/{x}',
          ],
          type: 'raster',
          tileSize: 256,
        },
        imageryParcelOutlines: {
          tiles: [
            'https://tiles.arcgis.com/tiles/fLeGjb7u4uXqeF9q/arcgis/rest/services/PWDParcel_ImageryOverlay/MapServer/tile/{z}/{y}/{x}',
          ],
          type: 'raster',
          tileSize: 256,
        },
        imageryLabels: {
          tiles: [
            'https://tiles.arcgis.com/tiles/fLeGjb7u4uXqeF9q/arcgis/rest/services/CityImagery_Labels/MapServer/tile/{z}/{y}/{x}',
          ],
          type: 'raster',
          tileSize: 256,
        },
        2023: {
          tiles: [
            'https://tiles.arcgis.com/tiles/fLeGjb7u4uXqeF9q/arcgis/rest/services/CityImagery_2023/MapServer/tile/{z}/{y}/{x}',
          ],
          type: 'raster',
          tileSize: 256,
        },
        // addressMarker: {
        //   type: 'geojson',
        //   data: {
        //     type: 'Feature',
        //     geometry: {
        //       type: 'Point',
        //       coordinates: [],
        //     }
        //   }
        // },
        liBuildingFootprints: {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          },
        },
      },
      layers: [
        {
          id: 'pwd',
          source: 'pwd',
          type: 'raster',
        },
        {
          id: 'pwdLabels',
          source: 'pwdLabels',
          type: 'raster',
        },
        {
          id: 'liBuildingFootprints',
          type: 'fill',
          source: 'liBuildingFootprints',
          layout: {},
          paint: {
            'fill-color': '#C2B7FF',
            'fill-opacity': 0.5,
          },
        },
        {
          id: 'liBuildingFootprintsLine',
          type: 'line',
          source: 'liBuildingFootprints',
          layout: {},
          paint: {
            'line-color': '#C2B7FF',
            'line-width': 2,
          }
        },
      ],
    },
    mapLayers: {
      imageryParcelOutlines: {
        id: 'imageryParcelOutlines',
        source: 'imageryParcelOutlines',
        type: 'raster',
        minzoom: 0,
        maxzoom: 22,
      },
      imageryLabels: {
        id: 'imageryLabels',
        source: 'imageryLabels',
        type: 'raster',
      },
      2023: {
        id: '2023',
        source: '2023',
        type: 'raster',
      },
    },
  },
};

Vue.use(configMixin, config);

library.add(faChevronRight, faSort)
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('Breadcrumbs', Breadcrumbs);


extend('date', {
  message: 'Enter date in format MM/DD/YYYY',
  validate: (value) => {
    console.log('Enter date in format MM/DD/YYYY', value, moment(value, 'M-D-YYYY').isValid())
    return moment(value, 'M-D-YYYY').isValid();
  },
});
extend('validDates', {
  message: 'Please enter a valid date range',
  validate:(value) => {
    console.log("validate year diff: ", value, Math.abs(moment(value, 'M-D-YYYY', true).diff(moment(), 'years')) < 10  )
    return Math.abs(moment(value, 'M-D-YYYY').diff(moment(), 'years')) < 10 ;
  },
});

extend('email', email);
extend('numeric', numeric);
extend('length', length);
extend('min', min);
extend('min_array_length', {
  validate(value, args) {
    return value.length >= args.length;
  },
  message (value, args) {
    return `Select at least ${args.length}`;
  },
  params: [ 'length' ],
});
extend('required', {
  ...required,
  message: 'This field is required',
});

Vue.use(PhilaUI, {});
Vue.use(ClientTable, {}, false, 'bulma');
Vue.use(ServerTable, {}, false, 'bulma');
Vue.use(VueFuse);
Vue.use(VueMeta);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
